import { fmt, escapeHtml } from "./util.js";

const sessions = [];

export function pushHistory(item, won, guesses) {
  const actual = item.amount;
  const best = guesses.reduce(
    (b, g) => Math.abs(g.guess - actual) < Math.abs(b - actual) ? g.guess : b,
    Infinity
  );
  sessions.unshift({
    title: item.title,
    imgUrl: item.imgUrl,
    amount: item.amount,
    currency: item.currency || "$",
    link: item.link,
    won,
    bestGuess: best !== Infinity ? best : null,
    guessCount: guesses.length,
  });
  updateBadge();
}

function updateBadge() {
  const btn = document.getElementById("cartBtn");
  if (!btn) return;
  let badge = btn.querySelector(".cart-count");
  if (sessions.length === 0) { badge?.remove(); return; }
  if (!badge) { badge = document.createElement("span"); badge.className = "cart-count"; btn.appendChild(badge); }
  badge.textContent = sessions.length;
}

function render(body) {
  if (sessions.length === 0) {
    body.innerHTML = '<div class="lb-state">No items played yet this session.</div>';
    return;
  }
  body.innerHTML = sessions.map(h => `
    <a class="hist-row ${h.won ? "hist-win" : "hist-lose"}" href="${h.link}" target="_blank" rel="noopener">
      <img class="hist-thumb" src="${h.imgUrl}" alt="" referrerpolicy="no-referrer" />
      <div class="hist-info">
        <div class="hist-title">${escapeHtml(h.title)}</div>
        <div class="hist-meta">${fmt(h.amount, h.currency)}${h.bestGuess !== null ? ` · guessed ${fmt(h.bestGuess, h.currency)}` : ""}</div>
      </div>
      <div class="hist-badge ${h.won ? "hist-win" : "hist-lose"}">${h.won ? "WIN" : "LOSS"}</div>
    </a>
  `).join("");
}

export function initHistory() {
  const overlay = document.getElementById("historyOverlay");
  const closeBtn = document.getElementById("historyClose");
  const body = document.getElementById("historyBody");

  document.addEventListener("click", (e) => {
    if (e.target.closest("#cartBtn")) { render(body); overlay.classList.add("open"); }
  });
  closeBtn.addEventListener("click", () => overlay.classList.remove("open"));
  overlay.addEventListener("click", (e) => { if (e.target === overlay) overlay.classList.remove("open"); });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("open")) overlay.classList.remove("open");
  });
}
